/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Form = __webpack_require__(1);

var _Form2 = _interopRequireDefault(_Form);

var _AlertRenderer = __webpack_require__(2);

var _AlertRenderer2 = _interopRequireDefault(_AlertRenderer);

var _CookieManager = __webpack_require__(6);

var _CookieManager2 = _interopRequireDefault(_CookieManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.formAlertRenderer = new _AlertRenderer2.default();

(function ($) {
    // jQuery plugin to be able to call formAlert() on any form to apply
    var form = new _Form2.default(formAlertRenderer, new _CookieManager2.default());
    $.fn.formAlert = function () {
        $(this).submit(function () {
            form.callback($(this).data('callback'));
            form.callbackError($(this).data('callback-error'));
            return form.submit(this);
        });
    };
})(jQuery);

$(document).ready(function () {
    // apply formAlert to all forms with the 'ajax' class
    $('body').on('submit', 'form.ajax', function () {
        var form = new _Form2.default(formAlertRenderer, new _CookieManager2.default());
        form.callback($(this).data('callback'));
        form.callbackError($(this).data('callback-error'));
        return form.submit(this);
    });
});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Form = function () {
    function Form(responseRenderer, cookieManager) {
        _classCallCheck(this, Form);

        this.renderer = responseRenderer;
        this.cookieManager = cookieManager;
    }

    _createClass(Form, [{
        key: 'callback',
        value: function callback(_callback) {
            this.callback = _callback;
        }
    }, {
        key: 'callbackError',
        value: function callbackError(_callbackError) {
            this.callbackError = _callbackError;
        }
    }, {
        key: 'runCallback',
        value: function runCallback(callback, form, json) {
            if (typeof callback !== 'undefined') {
                if (typeof callback == 'string') {
                    callback = window[callback];
                }

                callback(form, json);
            }
        }
    }, {
        key: 'submit',
        value: function submit(form) {
            // any messages should be hidden then reloaded in
            // in order to indicate if the form submitted, even
            // if it results in the same message
            $('.alert').hide();

            // set any buttons in the form to show loading and disable
            // to prevent multiple clicks
            var btns = $(form).find('.btn');
            btns.button('loading');

            var $this = this;
            $.post($(form).attr('action'), $(form).serialize()).done(function (data) {
                // re-enable form buttons
                btns.button('reset');

                try {
                    var json = $.parseJSON(data);
                } catch (err) {
                    // invalid JSON means some server-side error
                    // we'd still like to be able to handle that
                    $this.renderer.fail(data);
                    return;
                }

                if (typeof json['redirect'] !== "undefined" && json['redirect'].length > 0) {
                    // handle redirect
                    // save messages to display on redirect landing
                    $this.cookieManager.createCookie('redirectMessages', data, 1);
                    window.location = json['redirect'];
                    return;
                }

                $this.renderer.done(json);

                if (typeof json['errors'] !== "undefined") {
                    $this.runCallback($this.callbackError, form, json);
                    return false;
                }

                $this.runCallback($this.callback, form, json);
            }).fail(function (data) {
                // server error
                // try to display what information we do get
                btns.button('reset');
                $this.renderer.fail(data);
            });

            return false;
        }
    }]);

    return Form;
}();

exports.default = Form;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractRenderer2 = __webpack_require__(3);

var _AbstractRenderer3 = _interopRequireDefault(_AbstractRenderer2);

var _Messages = __webpack_require__(4);

var _Messages2 = _interopRequireDefault(_Messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AlertRenderer = function (_AbstractRenderer) {
    _inherits(AlertRenderer, _AbstractRenderer);

    function AlertRenderer() {
        _classCallCheck(this, AlertRenderer);

        return _possibleConstructorReturn(this, (AlertRenderer.__proto__ || Object.getPrototypeOf(AlertRenderer)).apply(this, arguments));
    }

    _createClass(AlertRenderer, [{
        key: 'done',
        value: function done(response) {
            new _Messages2.default(this.formatMessages(response)).show();
        }
    }, {
        key: 'fail',
        value: function fail(response) {
            // HTTP error, could be anything coming back

            var error;
            try {
                var errors = $.parseJSON(response.responseText);
                error = errors;
            } catch (err) {
                if (typeof response.responseText != 'undefined') error = response.responseText;else error = response;
            }

            this.done(error);
        }
    }, {
        key: 'formatMessages',
        value: function formatMessages(jsonMessages) {
            // try to figure out what to display as the error message

            if (typeof jsonMessages == 'string') {
                try {
                    jsonMessages = $.parseJSON(jsonMessages);
                } catch (err) {
                    jsonMessages = { 'errors': { 'errors': [{ 'friendly': jsonMessages, 'target': 'errors' }] } };
                }
            }

            var messagesObj;
            if (typeof jsonMessages['errors'] != 'undefined') {
                messagesObj = jsonMessages['errors'];
            } else {
                messagesObj = jsonMessages['messages'];
            }

            return messagesObj;
        }
    }]);

    return AlertRenderer;
}(_AbstractRenderer3.default);

exports.default = AlertRenderer;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AbstractRenderer = function () {
    function AbstractRenderer() {
        _classCallCheck(this, AbstractRenderer);
    }

    _createClass(AbstractRenderer, [{
        key: 'done',
        value: function done(response) {
            throw new TypeError(this.constructor.name + ' must implement the `done` method');
        }
    }, {
        key: 'fail',
        value: function fail(response) {
            throw new TypeError(this.constructor.name + ' must implement the `done` method');
        }
    }]);

    return AbstractRenderer;
}();

exports.default = AbstractRenderer;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Message = __webpack_require__(5);

var _Message2 = _interopRequireDefault(_Message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class Messages
 * maanges sets of messages for display
 */
var Messages = function () {
    function Messages(jsonMessages) {
        _classCallCheck(this, Messages);

        this.messages = {};

        for (var type in jsonMessages) {
            var arr = [];
            for (var i in jsonMessages[type]) {
                arr.push(new _Message2.default(jsonMessages[type][i]));
            }
            this.messages[type] = arr;
        }
    }

    _createClass(Messages, [{
        key: 'show',
        value: function show() {
            $('.field-error').removeClass('field-error');
            $('.fieldMessage').hide();
            for (var type in this.messages) {
                if ($('#' + type).length > 0) {
                    // clear any existing messages
                    $('#' + type).html('').hide();
                }

                for (var i in this.messages[type]) {
                    // show each message
                    var message = this.messages[type][i];
                    message.show(type, $('#' + type).data('timeout'));
                }

                if ($('#' + type).length > 0) {
                    // if any messages were shown, scroll to the container
                    $('html, body').animate({
                        scrollTop: $("#" + type).offset().top - 10
                    }, 200);
                }
            }
        }
    }]);

    return Messages;
}();

exports.default = Messages;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class Message
 * text to show to the user
 */
var Message = function () {
    function Message(message) {
        _classCallCheck(this, Message);

        this.message = message;
    }

    /**
     * display a message to the user
     *
     * @param string    type        also used to determine the element to show message in
     * @param int       fadeoutTime how long to wait until message disappears (null or 0 for never)
     * @return void
     */


    _createClass(Message, [{
        key: 'show',
        value: function show(type, fadeOutTime) {
            // if no messages have been shown yet, the list doesn't exist
            // create the list before trying to append to it
            var target = $(this.message.target);

            if (!target.hasClass('alert')) {
                return this.showField(type, fadeOutTime, target);
            }

            var list = target.find('ul');
            if (!list.length) {
                target.html('<ul></ul>');
                list = target.find('ul');
            }

            list.append('<li>' + this.tickToHtml(this.message.friendly) + '</li>');

            // don't try to re-fadein after every message, only the first one
            if (!target.is(':visible')) {
                target.fadeIn();
            }

            // generally want to fade out success messages after a short period
            if (fadeOutTime) {
                setTimeout(function (type) {
                    $('#' + type).fadeOut();
                }, fadeOutTime, type);
            }
        }

        /**
         * Show a message for a specific form field
         *
         * @param string type
         * @param int    fadeOutTime
         * @param string target
         * @return void
         */

    }, {
        key: 'showField',
        value: function showField(type, fadeOutTime, target) {
            target.removeClass('field-' + type).addClass('field-' + type);
            target.find('div.fieldMessage').remove();
            target.append('<div class="fieldMessage fieldMessage-' + type + '">' + this.message.friendly + '</span>');
        }

        /**
         * Covert backticks to an HTML tag enclosure in a string
         *
         * @param string    string      string to replace backticks in
         * @param string    tag         HTML tag to use to replace
         * @return string
         */

    }, {
        key: 'tickToHtml',
        value: function tickToHtml(string, tag) {
            if (typeof tag === 'undefined') tag = 'strong';

            return string.replace(/`(.*?)`/g, '<' + tag + '>$1</' + tag + '>');
        }
    }]);

    return Message;
}();

exports.default = Message;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CookieManager = function () {
    function CookieManager() {
        _classCallCheck(this, CookieManager);
    }

    _createClass(CookieManager, [{
        key: "createCookie",

        /**
         * Store a cookie
         * source: http://stackoverflow.com/questions/14573223/set-cookie-and-get-cookie-with-javascript
         *
         * @param string    name
         * @param string    value
         * @param int       days
         */
        value: function createCookie(name, value, days) {
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                var expires = "; expires=" + date.toGMTString();
            } else var expires = "";
            document.cookie = name + "=" + value + expires + "; path=/";
        }

        /**
         * Read a cookie from the browser
         * source: http://stackoverflow.com/questions/14573223/set-cookie-and-get-cookie-with-javascript
         *
         * @param string    name
         * @return string
         */

    }, {
        key: "readCookie",
        value: function readCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1, c.length);
                }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }

        /**
         * Delete a cookie from the browser
         * source: http://stackoverflow.com/questions/14573223/set-cookie-and-get-cookie-with-javascript
         *
         * @param string    name
         */

    }, {
        key: "eraseCookie",
        value: function eraseCookie(name) {
            this.createCookie(name, "", -1);
        }
    }]);

    return CookieManager;
}();

exports.default = CookieManager;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// formAlert.min.js